<template>
  <div style="overflow-x: auto">
    <h5 class="mb-2 mt-4">
      Участники
    </h5>
    <div class="container">
      <div class="row" v-if="showEventData">
        <div v-for="team in showEventData.teams" :key="'teams-event-data-' + team.team_id">
          <div v-if="host.hash == team.hash" class="mr-5 ">
            <h5 class="mb-4 mt-4">Команда: {{ team.info?.name }} Slot: {{ team.slot_number }}</h5>
            <table class="table">
              <thead>
              <tr>
                <th scope="col" class="p-0" style="width: 140px">Nick</th>
                <th scope="col" class="p-0">Kill</th>
                <th scope="col" class="p-0">Up</th>
                <th scope="col" class="p-0">Down</th>
                <th scope="col" class="p-0">Жив</th>
              </tr>
              </thead>
              <tbody>
              <RowInHostsBook v-for="member in team.members"
                              :key="member.user_id"
                              :disabled="showEventData?.type === 'ended'"
                              :member="member"
                              :team="team"
                              :kill-for-send="getPendingKill(team.team_id, member.user_id)"
                              :death-for-send="getPendingDeath(team.team_id, member.user_id, member)"
                              @update:killForSend="value => setPendingKill(team.team_id, member.user_id, value)"
                              @update:deathForSend="value => setPendingDeath(team.team_id, member.user_id, value)"
              />
              </tbody>
            </table>
            <div class="d-flex flex-wrap">
              <b-btn class="mt-2 mr-2"
                     variant="primary"
                     :disabled="showEventData?.type === 'ended' || isSending[team.team_id]"
                     @click="sendTeam(team)">
                Send
              </b-btn>
              <b-btn class="mt-2"
                     v-b-modal="'deathTeam' + team.team_id"
                     :disabled="showEventData?.type === 'ended'"
                     @click="teamNotEnterToLobby(team)"
              >
                Не вошла
              </b-btn>
            </div>
          </div>
        </div>

        <b-modal centered
                 id="deathTeamModal"
                 ref="deathTeamModal"
        >
          <p class="my-4">Команда {{ selectedTeam?.info?.name }} точно не вошла?</p>
          <template #modal-footer>
            <div>
              <b-btn variant="primary"
                     class="mr-3"
                     @click="storeAllTeamsWithDeath({
                                     matchId: selectedMatch,
                                     token: selectedTeam?.hash,
                                     teamId: selectedTeam?.team_id});
                                     $refs.deathTeamModal.hide();">
                Да
              </b-btn>
              <b-btn variant="danger" @click="$refs.deathTeamModal.hide();">Отмена</b-btn>
            </div>
          </template>
        </b-modal>
      </div>
      <div v-else-if="!showEventData?.teams" class="loading-wrapper">
        <b-spinner class="spinner"></b-spinner>
      </div>
    </div>
  </div>
</template>
<script>

import {BookAdapterMixin} from "@/mixins/Book/BookAdapterMixin";
import RowInHostsBook from "@/components/Live/RowInHostsBook.vue";

export default {
  name: 'HostsLive',
  components: {RowInHostsBook},
  mixins: [BookAdapterMixin],
  props: {
    host: {
      type: Object,
      require: true
    },
  },
  data() {
    return {
      striped: true,
      bordered: true,
      selectedTeam: {},
      pending: {},
      isSending: {},
    }
  },
  methods: {
    getPendingKill(teamId, userId) {
      return this.pending[teamId]?.[userId]?.kill ?? 0;
    },
    getPendingDeath(teamId, userId, member) {
      const stored = this.pending[teamId]?.[userId]?.death;
      if (stored !== undefined) return stored;
      return member?.death === 1 ? 1 : 0;
    },
    ensureBucket(teamId, userId, member) {
      if (!this.pending[teamId]) {
        this.$set(this.pending, teamId, {});
      }
      if (!this.pending[teamId][userId]) {
        this.$set(this.pending[teamId], userId, {
          kill: 0,
          death: member?.death === 1 ? 1 : 0,
        });
      }
    },
    setPendingKill(teamId, userId, value) {
      const member = this.showEventData?.teams
          ?.find(t => t.team_id === teamId)
          ?.members?.find(m => m.user_id === userId);
      this.ensureBucket(teamId, userId, member);
      this.pending[teamId][userId].kill = value;
    },
    setPendingDeath(teamId, userId, value) {
      const member = this.showEventData?.teams
          ?.find(t => t.team_id === teamId)
          ?.members?.find(m => m.user_id === userId);
      this.ensureBucket(teamId, userId, member);
      this.pending[teamId][userId].death = value;
    },
    async sendTeam(team) {
      const teamPending = this.pending[team.team_id] || {};
      const actions = team.members.map(member => {
        const entry = teamPending[member.user_id];
        const kill = entry ? entry.kill : 0;
        const death = entry ? entry.death : (member.death === 1 ? 1 : 0);
        return {user_id: member.user_id, kill, death};
      });
      this.$set(this.isSending, team.team_id, true);
      try {
        await this.storeKill({
          matchId: this.selectedMatch,
          token: team.hash,
          teamId: team.team_id,
          actions,
        });
        this.$set(this.pending, team.team_id, {});
      } finally {
        this.$set(this.isSending, team.team_id, false);
      }
    },
    teamNotEnterToLobby(team) {
      this.selectedTeam = team;
      this.$refs.deathTeamModal.show();
    }
  },
}
</script>
